import React, { useState, useRef, useEffect, useImperativeHandle, forwardRef, useMemo } from "react";
import {
  Button,
  TextField,
  Container,
  Grid,
  Typography,
  Divider,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Autocomplete,
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  CircularProgress,
  Modal,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  RadioGroup,
  Radio,
  makeStyles,
  styled,
  IconButton,
} from "@mui/material";
import { attentionColors, mobiliTheme } from "../../../../../themes/mobiliTheme";
import { Add, Check, CheckBox, Delete, PersonSearch } from "@mui/icons-material";
import Controls from "../../../../../atoms/Controls";
import TextArea from "../../../../../atoms/TextArea";
import { observer } from "mobx-react";
import { initialValues } from "../../../../pages/Patient/initialValues";
import useStore from "../../../../../helpers/useStore";
import {
  useMasterTables,
  resolveTarifGroupForRxType,
  getTherapyId,
} from "../../../../../stores/MasterTables";
import { DoctorContext } from "../../../../../stores/Doctor/doctor.provider";
import { RxStoreContext } from "../../../../../stores/Rx/rx.provider";
import { NoteDto, RxDto, RxDtoProcessingStatusEnum } from "../../../../../api-client";
import { v4 as uuidv4 } from "uuid";
import notificationStore from "../../../../../stores/Notification/notificationStore";
import { confirmDoctorClinicJoin } from "../../../../DoctorManagement/confirmDoctorClinicJoin";
import { confirmDoctorClinicMismatch } from "../../../../DoctorManagement/confirmDoctorClinicMismatch";
import { UserContext } from "../../../../../stores/User/User.provider";
import { useUserAccounts } from "../../../../../stores/User/User.hooks";
import DoctorDialog from "../../../../PatientDataEntryForm/Doctor";
import { PatientsContext } from "../../../../../stores/Patients/patients.provider";
import ValidationCardRxInfoPage from "../../../../../molecules/ValidationCardRxInfoPage";
import FlatCard from "../../../../../atoms/FlatCard";
import classes from "./Bundeswehr.module.css";
import ValidationCard, { formType } from "../../../../../molecules/ValidationCard";
import WarningDialog from "../../../../../atoms/WarningDialog";
import { NotesContext } from "../../../../../stores/Notes/notes.provider";
import Notes from "../../../../ScheduleOverview/Notes/Notes";
import { validateFrequency, validateTherapy } from "../../../../../molecules/Editable";
import { rxuseForm } from "../../../../PatientDataEntryForm/Form";
import {
  ClinicForModal,
  Doctor,
} from "../../../../DoctorManagement/DoctorTabContent/doctor-client-types";
import VerordnungDialog from "../Kasse/VerordnungDialog";
import moment from "moment";
import { resolveSourcedValue } from "../rxFieldSource";
import DoctorCard from "../../../../../molecules/DoctorCard";
import DoctorClinicAutocomplete from "../DoctorClinicAutocomplete";
import SimpleDocumentViewer from "../../../../Documents/SimpleDocumentViewer";
import { usePatient } from "../../../../../stores/Patients/patient.queries";
import { useRx } from "../../../../../stores/Rx/rx.queries";
import { useSaveRxs } from "../../../../../stores/Rx/rx.mutations";
import { EntryType } from "../../../../PatientDataEntryForm/Receipt";
import { formTherapyFromLine } from "../../../../../helpers/therapyRxLabel";
import { RxFormRow, rowNamesTerm, rowTermText } from "../../../../../helpers/rxFormRow";
import TherapyTermField from "../../../../../molecules/TherapyTermField";
import { usePrescribedTherapyOptions } from "../../../../../stores/MasterTables/masterTables.queries";

interface DiagnoseGroup {
  a: string;
  b: string;
  c: string;
  d: string;
}

interface BundeswehrProps {
  selectedRxId?: string;
  patientId?: number;
  handleNewFormData?: (data: RxDto) => void;
  newFormData?: any;
  values?: any; //required only entryType is newRx
  readOnlyView?: boolean;
  entryType?: EntryType;
  openRx?: boolean;
  onCloseRx?: any;
  updateRxProcessingStatus?: (event: any) => void;
}

const ScalableDiv = styled("div")(({ theme }) => ({
  transformOrigin: "top left",
  [theme.breakpoints.down("sm")]: {
    transform: "scale(0.6)",
  },
  [theme.breakpoints.between("sm", "xl")]: {
    transform: "scale(0.65)",
  },
  [theme.breakpoints.up("xl")]: {
    transform: "scale(0.85)",
  },
}));

const ScalableComponentSimple = ({ children }: any) => {
  return <ScalableDiv>{children}</ScalableDiv>;
};

const Bundeswehr: React.FC<BundeswehrProps> = observer(
  ({
    selectedRxId,
    patientId,
    handleNewFormData,
    values,
    newFormData,
    readOnlyView,
    entryType,
    onCloseRx,
    openRx,
    updateRxProcessingStatus,
  }) => {
    // const { rxFormData, patientValues, handleData, masterTablesData, readOnlyView } = props;
    // console.log("ghasjsajajdjdja", readOnlyView);
    const { data: masterTablesDataQuery } = useMasterTables();
    // Prescribed TERMS — the catalog level a prescription names (MD-232).
    const { data: termOptions = [] } = usePrescribedTherapyOptions();
    // Fetch RX data using the rxId from store
    const { data: rxData, isLoading: isRxLoading, error: rxError } = useRx(selectedRxId!);
    const rxFormData = entryType && newFormData ? newFormData : rxData;

    // Get patient data from store
    const { data: patientData } = usePatient(patientId!);
    const patientValues = entryType === EntryType.newRx && values ? values : patientData;
    const { mutate: patientSaveRxs } = useSaveRxs();

    const [unsavedChanges, setUnsavedChanges] = useState(false);
    const [unsavedChangesWarning, setShowunsavedChangesWarning] = useState(false);
    const UserStore = useStore(UserContext);
    const accounts = useUserAccounts();
    const patientStore = useStore(PatientsContext);
    const rxStore = useStore(RxStoreContext);
    const { savedSeriesForPatient } = rxStore;
    const { user } = UserStore;
    // Use prop masterTablesData or fallback to query data
    const safeMasterTablesData = masterTablesDataQuery || [];
    const [selectedDiagnoseGroup, setSelectedDiagnoseGroup] = useState<DiagnoseGroup | null>(null);
    const RxStore = useStore(RxStoreContext);
    const { saveRxs } = RxStore;
    const [loading, setLoading] = useState(false);
    // const [isDoctorNumberDisabled, setIsDoctorNumberDisabled] = useState(true);
    const [doesClinicExist, setDoesClinicExist] = useState(false);
    const [isClinicModalOpen, setIsClinicModalOpen] = useState(false);
    const [isClinicModalEditMode, setIsClinicModalEditMode] = useState(false);
    const [currentClinicId, setCurrentClinicId] = useState("");
    const [creationResponse, setCreationResponse] = useState<any>({
      id: "",
      clinics: [],
      contactInfo: {},
      doctorId: "",
      clinicId: "",
    });
    const [currentDoctorId, setCurrentDoctorId] = useState("");
    const [doesDoctorExist, setDoesDoctorExist] = useState(false);
    const [currentClinic, setCurrentClinic] = useState<ClinicForModal | undefined>();
    const [showClinicData, setShowClinicData] = useState(false);
    const [currentDoctor, setCurrentDoctor] = useState<Doctor | ClinicForModal>();
    const [autocompleteSearchTerm, setAutocompleteSearchTerm] = useState("");

    //For payer
    const insurer = safeMasterTablesData
      .filter((obj: any) => "insurer" in obj) // Filter objects that have the insurer property
      .map((obj: any) => obj.insurer);
    const [selectedPayer, setSelectedPayer] = useState(null);
    const [selectedChipCard, setSelectedChipCard] = useState<string | null>(null);
    const diagnoseGroups = safeMasterTablesData
      .filter((obj: any) => "diagnosisGroups" in obj)
      .map((obj: any) => obj.diagnosisGroups);

    const rxType = safeMasterTablesData
      .filter((obj: any) => "rxType" in obj) // Filter objects that have the insuranceStatus property
      .map((obj: any) => obj.rxType);
    //  therapyOptions= therapyOptions[0].filter(
    //       (therapyObj: any) =>

    //         therapyObj.duration
    //     )

    //For Doctor
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const DoctorStore = useStore(DoctorContext);
    const { getClinicById, getDoctorById, createDoctorWithClinic } = DoctorStore;
    const [isSelectActive, setIsSelectActive] = useState(false);
    const [isAddEditDialogOpen, setAddEditDialogOpen] = useState(false);

    const account = safeMasterTablesData
      .filter((obj: any) => "account" in obj)
      .map((obj: any) => obj.account);
    const NotesStore = useStore(NotesContext);
    const { getRxNotes, updateNoteById, postNotes, fetchNotes } = NotesStore;
    const [rxNotes, setRxNotes] = useState<NoteDto[]>([]);

    // Position und DocumentViewer State-Variablen
    const [position, setPosition] = useState<"default" | "right-third">("default");
    const [documentViewerOpen, setDocumentViewerOpen] = useState(false);
    useEffect(() => {
      const fetchData = async () => {
        try {
          if (selectedRxId) {
            const response = await getRxNotes(selectedRxId!);

            setRxNotes(response);
          }
        } catch (error) {
          // console.log("error", error);
        }
      };

      fetchData();
    }, [selectedRxId, fetchNotes]);
    const updateNote = async (index: number, updatedCard: NoteDto) => {
      updatedCard.rxId = selectedRxId!;
      if (updatedCard.id) {
        await updateNoteById(updatedCard.id, user?.id as string, updatedCard);
      } else {
        await postNotes(user?.id as string, updatedCard);
      }
      const updatedNotes = [...rxNotes];
      updatedNotes[index] = updatedCard;
      setRxNotes(updatedNotes);
    };

    /**
     * "" is what an untouched form field holds; null is what a nullable column
     * accepts. Only the empty string is converted — false, 0 and a real value
     * all pass through, so an explicitly unticked box stays unticked.
     */
    const emptyToNull = <T,>(value: T): T | null =>
      (value as unknown) === "" ? null : value;

    const initialrxValues = {
      Receiptpayer: "",
      address: "",

      status: "",
      signatureStatus: "",
      insuranceStatus: "",
      chipcard: "",
      tarifGroupId: "",
      insureeNumber: "",
      rxtype: "Kasse",
      accountId: "",

      isPerpetual: false,

      practiceNumber: "",
      doctorNumber: "",
      doctorId: "",
      clinicId: "",
      date: "",
      isCopaymentExempted: true,
      isAccident: false,
      isBVG: false,
      icdCodeEntries: [{ userText: "" }, { userText: "" }],
      diagnosisText: "",
      diagnosegroup: null,
      a: "",
      b: "",
      c: "",
      d: "",
      hasIndividualSymptoms: false,
      therapyRxs: [
        {
          id: uuidv4(),
          amount: "",
          frequency: { id: "", text: "" },
          therapy: {
            id: "",
            HMP4: "",
            price: "",
            abbreviation: "",
            description: "",
          },
          // MD-232: the prescribed term as typed. The server resolves it
          // text -> alias -> term; declared here so the line type carries it.
          rawText: null as string | null,
          isDoubled: false,
          rxSeries: { label: "" },
        },
        {
          id: uuidv4(),
          amount: "",
          frequency: { id: "", text: "" },
          therapy: {
            id: "",
            HMP4: "",
            price: "",
            abbreviation: "",
            description: "",
          },
          // MD-232: the prescribed term as typed. The server resolves it
          // text -> alias -> term; declared here so the line type carries it.
          rawText: null as string | null,
          isDoubled: false,
          rxSeries: { label: "" },
        },
        {
          id: uuidv4(),
          amount: "",
          frequency: { id: "", text: "" },
          therapy: {
            id: "",
            HMP4: "",
            price: "",
            abbreviation: "",
            description: "",
          },
          // MD-232: the prescribed term as typed. The server resolves it
          // text -> alias -> term; declared here so the line type carries it.
          rawText: null as string | null,
          isDoubled: false,
          rxSeries: { label: "" },
        },
      ],
      isHomeVisit: rxFormData?.isHomeVisit ?? null,
      therapyReport: rxFormData?.therapyReport ?? null,
      urgent: false,
      symptoms: "",
      therapyFrequency: "",
      amount: "",
      additionalNotes: "",
      additionalNotes2: "",
      duplicate: false,
      validStartWindow: "",
      rxExpireDate: null,
      processingStatus: RxDtoProcessingStatusEnum.InBehandlung,
      clinic: {} as any,
    };

    const [formData, setFormData] = useState(initialrxValues);
    const [filteredTherapies, setFilteredTherapies] = useState([]);


    // Patient-only fields: never live on the Rx entity, so read them straight
    // from the patient record (the single source of truth).
    const patientLastName = patientValues?.lastName || "";
    const patientFirstName = patientValues?.firstName || "";

    // Dual-sourced fields (saved on both the Rx and the patient record). formData
    // holds the Rx-native value; the resolver applies the patient fallback for
    // display while exposing `.source` ("rx" | "patient" | "none") so the UI can
    // make the data's origin transparent to the user.
    const insureeNumberField = resolveSourcedValue<string>(
      formData?.insureeNumber,
      patientValues?.insuranceNo,
    );
    const insuranceStatusField = resolveSourcedValue<string>(
      formData?.insuranceStatus,
      patientValues?.status,
    );
    const therapyOptions = safeMasterTablesData
      .filter((obj: any) => "therapy" in obj)
      .map((obj: any) => obj.therapy)[0]
      ?.filter((option: any) => option.tarifGroup.id === formData.tarifGroupId);

    // Derive therapyType from the selected account (Physio vs. Ergo)
    const accountTherapyType = useMemo(() => {
      if (!formData.accountId || !accounts) return "Physiotherapie";
      const selectedAccount = accounts.find(
        (a: any) => a.name === formData.accountId || a.id === formData.accountId
      );
      return selectedAccount?.therapyType || "Physiotherapie";
    }, [formData.accountId, accounts]);

    // Only the groups the chosen Rezept-typ can be billed against — narrowed
    // further to the ones this practice's therapy type actually has line items
    // for, so the invariant cannot be broken by hand either.
    const tarifGroupOptions = useMemo(
      () =>
        resolveTarifGroupForRxType(
          safeMasterTablesData,
          formData?.rxtype,
          formData?.tarifGroupId,
          accountTherapyType
        ).options,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [safeMasterTablesData, formData?.rxtype, formData?.tarifGroupId, accountTherapyType]
    );

    const filterTherapies = () => {
      const filtered = therapyOptions?.filter(
        (option: any) => option.tarifGroup.id === formData.tarifGroupId &&
          (!option.therapyType || option.therapyType === accountTherapyType)
      );
      setFilteredTherapies(filtered);
    };

    useEffect(() => {
      filterTherapies();
    }, [formData.rxtype, formData.tarifGroupId, accountTherapyType]);

    useEffect(() => {
      setCurrentDoctor(rxFormData?.doctor as any);
      setCurrentClinic(rxFormData?.clinic as any);
    }, [rxFormData?.doctor, rxFormData?.clinic]);

    // Keep display fields in sync with the actual doctor/clinic LANR/BSNR
    useEffect(() => {
      if (currentDoctor) {
        const lanr = (currentDoctor as any).LANR || "";
        setFormData((prev) => ({ ...prev, doctorNumber: lanr, doctorId: currentDoctor.id || prev.doctorId }));
      }
    }, [currentDoctor]);

    useEffect(() => {
      if (currentClinic) {
        const bsnr = (currentClinic as any).BSNR || "";
        setFormData((prev) => ({ ...prev, practiceNumber: bsnr, clinicId: currentClinic.id || prev.clinicId }));
      }
    }, [currentClinic]);

    useEffect(() => {
      if (creationResponse && creationResponse.doctorId && creationResponse.clinicId) {
        setCurrentDoctor({
          id: creationResponse.doctorId,
          LANR: creationResponse.LANR,
          contactInfo: creationResponse.contactInfo as any,
          clinics: creationResponse.clinics,
        });
        const matchedClinic = (creationResponse.clinics || []).find((clinic: any) => clinic.id === creationResponse.clinicId);
        setCurrentClinic(matchedClinic as any || undefined);
        setFormData((prev) => ({
          ...prev,
          doctorId: creationResponse.doctorId || "",
          clinicId: creationResponse.clinicId || "",
          doctorNumber: creationResponse.LANR || "",
          practiceNumber: matchedClinic?.BSNR || "",
        }));
      }
    }, [creationResponse]);

    const [icdCodeEntries, setIcdCodeEntries] = useState(initialrxValues.icdCodeEntries);
    const handleUnsavedChangesWarning = () => {
      handleGenericSubmit();
    };
    const handleCloseRxDialog = () => {
      // console.log("shjsakjsajj", unsavedChanges);
      if (unsavedChanges) {
        // If there are unsaved changes, set a state to open the warning dialog
        setShowunsavedChangesWarning(true);
      } else {
        onCloseRx();
      }
    };
    const handleCloseUnsavedChangesWarning = () => {
      onCloseRx();
      // If user cancels and chooses not to continue, close the warning dialog
      setShowunsavedChangesWarning(false);
    };

    const rxvalidate = (fieldValues = formData) => {
      let temp: any = { ...rxerrors };
      if ("accountId" in fieldValues) temp.accountId = fieldValues.accountId ? "" : "Pflichtfeld";
      if ("tarifGroupId" in fieldValues)
        temp.tarifGroupId = fieldValues.tarifGroupId ? "" : "Pflichtfeld";

      rxsetErrors({
        ...temp,
      });

      if (fieldValues == formData) return Object.values(temp).every((x) => x == "");
    };
    const { rxerrors, rxsetErrors } = rxuseForm(formData, true, rxvalidate);

    // useEffect(() => {
    //   if (rxFormData) {
    //     // Populate the form data with values from rxFormData
    //     setFormData(rxFormData);
    //   } else {
    //     // Use empty values for form data
    //    setFormData(initialrxValues)
    //   }
    // }, [rxFormData]);
    // Initialize with two input boxes

    // Expose the submitForm function to the parent component

    const formattedRxData = (rxFormData: any, initialTherapyRxs: any) => {
      let icdCodeEntries;

      if (rxFormData.icdCodeEntries && rxFormData.icdCodeEntries.length > 0) {
        if (rxFormData.icdCodeEntries.length === 1) {
          icdCodeEntries = [...rxFormData.icdCodeEntries, { userText: "" }];
        } else {
          icdCodeEntries = rxFormData.icdCodeEntries;
        }
      } else {
        icdCodeEntries = [{ userText: "" }, { userText: "" }];
      }
      const updatedFormData = {
        ...rxFormData,
        diagnosisText: rxFormData?.diagnosisText || "",
        additionalNotes: rxFormData?.additionalNotes || "",
        additionalNotes2:rxFormData?.additionalNotes2 || "",
        symptoms: rxFormData?.symptoms || "",

        // Keep these Rx-native. The patient-record fallback is applied at the
        // display/save boundary via resolveSourcedValue so provenance (Rx vs
        // patient) stays distinguishable. Patient-only fields (name, DOB) are
        // not snapshotted here and are read directly from patientValues.
        insureeNumber: rxFormData?.insureeNumber || "",
        insuranceStatus: rxFormData?.insuranceStatus || "",
        // Receiptpayer: rxFormData.payer.insurer || "",
        Receiptpayer:
          rxFormData?.payer?.name ||
          insurer[0]?.find((option: any) => option.id === "Bundeswehr")?.name,
        chipcard: rxFormData?.payer?.ik || "Bundeswehr",
        diagnosegroup:
          diagnoseGroups[0]?.find((option: any) => option.id === rxFormData.diagnosegroup)?.code ||
          rxFormData.diagnosisGroup?.code,
        rxtype:
          rxType[0]?.find((option: any) => option.id === rxFormData.rxtype)?.text ||
          rxFormData.rxtype?.text ||
          "Kasse",
        accountId:
          account[0]?.find((option: any) => option.id === rxFormData.accountId)?.name ||
          rxFormData.account?.name,
        status: rxFormData.status || "",
        signatureStatus: rxFormData.signatureStatus || "",
        therapyRxs: initialTherapyRxs,
        // rxtype:rxFormData.rxtype?.id || "",
        // accountId:rxFormData.account?.id || "",
        // chipcard: rxFormData.payer?.id || "",
        // doctorId: rxFormData.doctor?.contactInfo?.lastName || "",
        bsnr: rxFormData.clinicId || rxFormData.practiceNumber || "",
        // diagnosegroup: rxFormData.diagnosisGroup?.code || "",
        icdCodeEntries: icdCodeEntries,
        // Map new API field names to form's internal keys
        doctorNumber: rxFormData.LANR || "",
        practiceNumber: rxFormData.BSNR || "",
        doctorId: rxFormData.doctorId || rxFormData.doctorNumber || "",
        clinicId: rxFormData.clinicId || rxFormData.practiceNumber || "",
      };
      return updatedFormData;
    };

    useEffect(() => {
      const fetchData = async () => {
        if (rxFormData && rxFormData.rxNumber) {
          // rxFormData = patientValues?.rxs.find(
          //   (rx: any) => rx.id === rxFormData.id
          // );
          // console.log(
          //   "After checking RxFormdata and Patient Value",
          //   rxFormData,
          //   " and",
          //   patientValues.rxs
          // );
          // let rxs: [] = [];

          rxFormData.therapyRxs = rxFormData?.therapyRxs?.flatMap((therapy: any): RxFormRow => {
            // Extract therapyRxs from each rx, or default to an empty array
            // Map therapyRxs to the desired format
            // console.log("Therapy Log DATA", therapy, therapy.frequency);
            return {
              id: therapy.id,
              date: rxFormData.date,
              // Carried through the round trip: this is what names the term on
              // save. An API line has `rawText`; fall back to the term id so a
              // line stored before rawText existed still resolves.
              rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
              therapy: formTherapyFromLine(therapy, therapyOptions),
              amount: therapy.amount,
              frequency: therapy.frequency
                ? therapy.frequency.id
                  ? therapy.frequency
                  : { id: therapy?.frequency, text: therapy?.frequency }
                : null,
              // Doubling is `unitsPerDay` since MD-232 — the server no longer
              // sends a persisted `isDoubled`. Carry both: the checkbox reads
              // the boolean, every save channel reads `unitsPerDay`.
              unitsPerDay: therapy.unitsPerDay,
              isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
              rxSeries: rxFormData.rxSeries ?? therapy.rx?.rxSeries,
            };
          });

          const initialTherapyRxs = Array.from({ length: 3 }, (_, index) => {
            if (index < (rxFormData.therapyRxs ? rxFormData.therapyRxs.length : 0)) {
              // If index is within the length of formData.therapyRxs, use existing data
              return rxFormData.therapyRxs?.[index];
            } else {
              // Otherwise, add an empty row
              return {
                id: uuidv4(),
                amount: "",
                frequency: { id: "", text: "", prefferedValue: "" },
                therapy: {
                  id: "",
                  HMP4: "",
                  price: "",
                  abbreviation: "",
                  description: "",
                },
                isDoubled: false,
                // rxSeries:{}
              };
            }
          });
          // Update form data based on fetched data

          const updatedFormData = formattedRxData(rxFormData, initialTherapyRxs);

          // Update form data state
          setFormData(updatedFormData);

          // Optionally, return the updated form data
          return updatedFormData;
        }
        // Make API request to fetch patient data based on patient ID or any other identifier
        else {
          // If no selectedRow, check if therapytableData exists
          const therapyRxs: any =
            rxFormData?.therapyRxs && rxFormData?.therapyRxs?.length
              ? Array.from({ length: 3 }, (_, index) => ({
                  ...rxFormData.therapyRxs?.[index],
                  id: rxFormData.therapyRxs?.[index]?.id || uuidv4(),
                  amount: rxFormData.therapyRxs?.[index]?.amount || "",
                  frequency: rxFormData.therapyRxs?.[index]?.frequency
                    ? rxFormData.therapyRxs?.[index]?.frequency
                    : { id: "", text: "" },

                  therapy: rxFormData.therapyRxs?.[index]?.therapy
                    ? rxFormData.therapyRxs?.[index]?.therapy
                    : { id: "", abbreviation: "" },
                }))
              : initialrxValues.therapyRxs;

          const updatedData = formattedRxData(rxFormData, therapyRxs);
          // console.log("akjakjsjsjjsa", updatedData);

          // Set form values using therapytableData or default to initialrxValues
          setFormData(updatedData);
        }
      };
      fetchData();

      // Only Rx-native data is snapshotted into formData now, so this effect just
      // tracks rxFormData. Patient-record fields (name, DOB, and the insurance
      // fallbacks) are read directly from patientValues at render time, which also
      // removes the prior timing bug where the patient loading after the Rx left
      // the name blank when navigating directly to an Rx.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rxFormData]);
    // console.log("ajkkjsakskkdska", formData.therapyReport);
    useEffect(() => {
      if (formData.diagnosegroup) {
        const diagnoseGroupIsId = diagnoseGroups[0].some(
          (group: any) => group.id === formData.diagnosegroup
        );
        // Find the matching diagnose group based on the selected code
        const selectedDiagnoseGroup = diagnoseGroupIsId
          ? diagnoseGroups[0].find((group: any) => group.id === formData.diagnosegroup)
          : diagnoseGroups[0].find((group: any) => group.code === formData.diagnosegroup);

        if (selectedDiagnoseGroup) {
          // Generate symptoms based on selected checkboxes
          let selectedSymptoms = "";
          if (formData.a) selectedSymptoms += selectedDiagnoseGroup.a + " ";
          if (formData.b) selectedSymptoms += selectedDiagnoseGroup.b + " ";
          if (formData.c) selectedSymptoms += selectedDiagnoseGroup.c + " ";
          if (formData.d) selectedSymptoms += selectedDiagnoseGroup.d + " ";
          setSelectedDiagnoseGroup(selectedDiagnoseGroup);
          setFormData((prevValues: any) => ({
            ...prevValues,
            a: selectedDiagnoseGroup.a ? prevValues.a : false,
            b: selectedDiagnoseGroup.b ? prevValues.b : false,
            c: selectedDiagnoseGroup.c ? prevValues.c : false,
            d: selectedDiagnoseGroup.d ? prevValues.d : false,
            ...(prevValues.hasIndividualSymptoms ? {} : { symptoms: selectedSymptoms.trim() }),
          }));
        }
      }
    }, [formData.diagnosegroup, formData.a, formData.b, formData.c, formData.d]);

    const handleChange = (event: any, index?: any) => {
      const { name, value } = event.target;
      const updatedTherapyRxs: any = [...formData.therapyRxs];
      updatedTherapyRxs[index][name.split(".")[1]] = value;
      setFormData({ ...formData, therapyRxs: updatedTherapyRxs });
    };
    const handleOpenAddEditDialog = (lanr: string | null, bsnr: string | null) => {
      setAddEditDialogOpen(true);
    };

    const handleDeleteTherapy = (therapyId: string) => {
      // Filter out the therapy that matches the given ID
      const updatedTherapies = formData.therapyRxs.filter((therapy) => therapy.id !== therapyId);

      // Update formData state with new therapy list
      setFormData({
        ...formData,
        therapyRxs: updatedTherapies,
      });
    };

    const handleCloseAddEditDialog = (data: any) => {
      // Handle doctor data, LANR, and BSNR passed back from DoctorDialog
      setAddEditDialogOpen(false);

      // Here you can perform further actions with the received data
      if (data && "number" in data) {
        const { number, clinicNumber, contactInfo, id } = data;

        // Update states or perform other operations based on the received data
        setSelectedDoctor(contactInfo?.lastName);
        setFormData((prevFormValues: any) => ({
          ...prevFormValues,
          doctorId: id || number,
          clinicId: data.clinicId || clinicNumber,
          doctorNumber: number,
          clinicNumber: clinicNumber,
        }));

        // For example, you can update doctor form values if needed
        // setDoctorFormValues(doctorData);
      }
    };
    const handleAddInput = () => {
      setIcdCodeEntries([...icdCodeEntries, { userText: "" }]);

      // Update the formValues state as well to reflect the new entry
      setFormData((prevValues: any) => ({
        ...prevValues,
        icdCodeEntries: [...prevValues.icdCodeEntries, { userText: "" }],
      }));
    };

    // const updateRxProcessingStatus=async(event:any)=>{
    //   const response=await updateprocessingStatus(rxFormData.id,event?.target.value)
    // }
    const [isHausbesuchSelected, setHausbesuchSelected] = useState<boolean | null>(
      formData.isHomeVisit
    );
    const handleCheckboxChange = (event: any) => {
      const selectedValue = event.target.value; // "yes" or "no"

      if (selectedValue === "yes") {
        setHausbesuchSelected(true);
        // Set isHomeVisit to true if "yes" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: true,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else if (selectedValue === "no") {
        setHausbesuchSelected(false);
        // Set isHomeVisit to false if "no" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: false,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else {
        setHausbesuchSelected(null); // Set null if neither is selected
        // Set isHomeVisit to null if neither checkbox is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: null,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      }
    };

    const handleInputChange = (
      event: React.ChangeEvent<HTMLInputElement>,
      index?: any,
      idValue?: string
    ) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { name, value, checked, type, id } = event.target;
      setUnsavedChanges(true);

      const inputValue = type === "checkbox" ? checked : value;

      if (name === "practiceNumber") {
        // No character limit for Bundeswehr Rxs — allow UUIDs and non-standard IDs
      }

      if (name === "doctorNumber") {
        // No character limit for Bundeswehr Rxs — allow UUIDs and non-standard IDs
        // Only update the field, do not clear doctor info here!
        setFormData((prevValues: any) => ({
          ...prevValues,
          doctorNumber: value,
        }));
        return;
      }

      if (name === "date" && formData.isPerpetual && value) {
        setFormData((prevValues: any) => ({
          ...prevValues,
          unvirtualize: true,
        }));
      }

      const updatedTherapyRxs = [...formData.therapyRxs];

      if (name === "therapy") {
        // MD-232: the line names the prescribed TERM as the text that was
        // typed, and the server resolves it text -> alias -> term on save.
        // Previously this looked the value up among tarif-bound BILLABLE LINE
        // ITEMS and wrote state only on a hit — so a real term like "KG-ZNS",
        // which is no line item's abbreviation, stored nothing at all and the
        // save reached the server naming no term ("Heilmittel unbekannt").
        // `abbreviation` is kept in step because the table cell reads it.
        if (value) {
          updatedTherapyRxs[index] = {
            ...updatedTherapyRxs[index],
            rawText: value,
            therapy: {
              ...updatedTherapyRxs[index].therapy,
              abbreviation: value,
            },
          };
        } else {
          // Cleared: drop the term as well as the display value.
          updatedTherapyRxs[index] = {
            ...updatedTherapyRxs[index],
            rawText: null,
            therapy: { id: "", HMP4: "", abbreviation: "", description: "", price: "" },
          };
        }
        setFormData((prevformValues: any) => ({
          ...prevformValues,
          therapyRxs: updatedTherapyRxs,
        }));
      }

      if (name === "amount") {
        updatedTherapyRxs[index] = {
          ...updatedTherapyRxs[index],
          amount: value,
        };

        setFormData((prevformValues) => ({
          ...prevformValues,
          therapyRxs: updatedTherapyRxs,
        }));
      }
      if (name === "frequency") {
        updatedTherapyRxs[index] = {
          ...updatedTherapyRxs[index],
          frequency: {
            id: value,
            text: value,
          },
        };

        setFormData((prevformValues) => ({
          ...prevformValues,
          therapyRxs: updatedTherapyRxs,
        }));
      }

      if (name === "rxSeries") {
        // Update therapyRxs based on rowIndex and therapyId
        const updatedTherapyRxs = formData.therapyRxs.map((therapy: any, index: number) => {
          if (index === index && therapy.id === idValue) {
            return {
              ...therapy,
              rxSeries: { id: id, label: value },
            };
          }
          return therapy;
        });

        // Update the formData state with the updated therapyRxs
        setFormData((prevFormData) => ({
          ...prevFormData,
          therapyRxs: updatedTherapyRxs,
        }));
      }
      if (name === "therapyFrequency") {
        // Update the frequency for the specific therapy row
        const updatedTherapyRxs = formData.therapyRxs.map((therapy: any, index: number) => {
          return {
            ...therapy,
            frequency: {
              id: value, // Update the frequency id
              text: value, // Update the frequency text
            },
          };
        });

        // Update the formData state with the updated therapyRxs
        setFormData((prevFormData) => ({
          ...prevFormData,
          therapyRxs: updatedTherapyRxs,
        }));
      }

      if (name.startsWith("icdCodeEntries")) {
        const inputElement = document.querySelector(`[name="${name}"]`) as
          | HTMLInputElement
          | HTMLTextAreaElement;
        const cursorPosition = inputElement?.selectionStart || 0;
        let updatedValue = value;
        let newCursorPosition = cursorPosition; // Initialize new cursor position

        // Check if the length is at least 4 and if a period needs to be inserted
        if (value.length >= 4) {
          // Check if the period already exists at the correct position
          if (!value.includes(".")) {
            // Insert a period after the third character if it's not already there
            updatedValue = value.slice(0, 3) + "." + value.slice(3);

            // Adjust cursor position if a period was inserted before the original cursor position
            if (cursorPosition > 3) {
              newCursorPosition = cursorPosition + 1; // Move cursor one position forward
            }
          }
        }

        // Update the form values with the correctly formatted value
        setFormData((prevValues: any) => ({
          ...prevValues,
          icdCodeEntries: prevValues.icdCodeEntries.map((icdEntry: any, i: number) => {
            return i === index
              ? { id: idValue || undefined, userText: updatedValue }
              : { id: icdEntry?.id, userText: icdEntry?.userText || "" };
          }),
        }));

        // Restore cursor position after the update
        setTimeout(() => {
          if (inputElement) {
            inputElement.selectionStart = inputElement.selectionEnd = newCursorPosition;
          }
        }, 0);
      }

      if (name === "rxtype") {
        // The Rezept-typ DECIDES the tarif group. Without this the group the Rx
        // was opened with survived the type change, so a type switched to
        // Privat here was still billed against the old group.
        const selectedRxTypeId = String(id ? id : inputValue);
        const { nextTarifGroupId, requiresChoice } = resolveTarifGroupForRxType(
          safeMasterTablesData,
          selectedRxTypeId,
          formData?.tarifGroupId,
          accountTherapyType
        );
        setFormData((prevValues) => ({
          ...prevValues,
          diagnosegroup: null, // Clear diagnosegroup when rxtype changes
          tarifGroupId: nextTarifGroupId,
        }));
        if (requiresChoice) {
          notificationStore.showMessage(
            "Bitte wählen Sie eine Tarifgruppe für den gewählten Rezept-Typ.",
            "warning"
          );
        }
        filterDiagnoseGroups(selectedRxTypeId);
      }

      // if (name === "doctorNumber") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.number === Number(value)
      //   );
      //   // setFetchedData(selectedDoctor);
      //   console.log("UZZHHHH", selectedDoctor);
      //   if (selectedDoctor) {
      //     setFormData((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       doctorId: selectedDoctor.id,
      //       practiceNumber: selectedDoctor.clinicNumber,
      //       doctorData:selectedDoctor
      //     }));
      //     setSelectedDoctor(selectedDoctor.contactInfo.lastName);
      //     setSelectedBSNR(selectedDoctor.clinicNumber);
      //   }
      // }
      // Leitsymptomatik: the a/b/c/d codes and the patientenindividuelle flag are
      // independent — a Verordnung can require both, so neither clears the other.
      // Update form fields based on their names
      setFormData((prevValues: any) => ({
        ...prevValues,
        [name]: id ? id : inputValue,
      }));

      // if (name === "doctorNumber") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.number === Number(value)
      //   );
      //   setFetchedData(selectedDoctor);
      //   console.log("UZZHHHH", selectedDoctor);
      //   if (selectedDoctor) {
      //     setFormData((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       doctorId: selectedDoctor.id,
      //       practiceNumber: selectedDoctor.clinicNumber,
      //     }));
      //     setSelectedDoctor(selectedDoctor.contactInfo.lastName);
      //     setSelectedBSNR(selectedDoctor.clinicNumber);
      //   }
      // }
      // if (insurer[0]) {
      //   if (name === "Receiptpayer") {
      //     // Autopopulate doctor and bsnr based on LANR selection

      //     const selectedPayer: any = insurer[0].find(
      //       (option: any) => option.id === id || option.ik === value
      //     );
      //     console.log("UZZHHHH", selectedPayer);
      //     if (selectedPayer) {
      //       setFormData((prevFormValues: any) => ({
      //         ...prevFormValues,
      //         chipcard: selectedPayer?.ik,
      //         tarifGroupId: selectedPayer?.tarifGroup?.id,
      //       }));
      //       setSelectedChipCard(selectedPayer.ik);
      //       console.log("selectedPayer", selectedPayer.name);
      //     }
      //   }

      //   if (name === "chipcard") {
      //     const selectedPayer: any = insurer[0].find((option: any) => option.ik === value);
      //     console.log("UZZHHHH", selectedPayer);
      //     if (selectedPayer) {
      //       setFormData((prevFormValues: any) => ({
      //         ...prevFormValues,
      //         Receiptpayer: selectedPayer.id,
      //         tarifGroupId: selectedPayer?.tarifGroup?.id,
      //       }));

      //       setSelectedPayer(selectedPayer.name);
      //       console.log("selectedPayer", selectedPayer.name);
      //     }
      //   }
      // }
    };

    const handleGenericSubmit = async (event?: any) => {
      if (event) {
        setLoading(false);
        event.preventDefault(); // Prevent default form submission behavior
      }
      try {
        // console.log("azajjaj", formData, formData.therapyRxs);
        if (rxvalidate()) {
          // The doctor must actually be registered at the practice the Rx names:
          // the stamp takes its telephone number from the PRACTICE, so a
          // mismatched pair prints a stranger's number on a document that leaves
          // the building. Asked here rather than on a field, because the Arzt-Nr
          // check only fires when that field loses focus - correcting the BSNR
          // afterwards, or re-saving an Rx loaded from the database, slips past it.
          if (!(await confirmDoctorClinicMismatch(currentDoctor, currentClinic))) {
            return;
          }
          setLoading(true);
          const updatedRxValues: any = {
            ...formData,
            // `a`-`d` are boolean columns and `date` is a date column, both
            // nullable — but the form holds "" for anything it was not given,
            // and Postgres rejects "" outright rather than reading it as
            // "not stated". The Rx then never saves and the dialog closes,
            // taking the entry with it.
            //
            // Empty is ordinary here: of 15,365 prescriptions in production
            // 4,030 carry no date and 3,737 no `a`. Planning before the paper
            // prescription arrives is the normal workflow.
            //
            // Seen first on the Blankoverordnung (MD-514 follow-up). These
            // three forms carry the identical initial values and the identical
            // `{...formData}` spread — they survive only when the Leitsymptom
            // effect happens to run, which it does not when no Diagnosegruppe
            // is chosen. Fixing them together so the fault cannot simply move.
            a: emptyToNull(formData.a),
            b: emptyToNull(formData.b),
            c: emptyToNull(formData.c),
            d: emptyToNull(formData.d),
            date: emptyToNull(formData.date),
              id: rxFormData?.id || "",
            rxNumber: rxFormData?.rxNumber || "",
            doctorNumber: formData.doctorNumber,
            practiceNumber: formData.practiceNumber,
            LANR: formData.doctorNumber || "",
            BSNR: formData.practiceNumber || "",
            // Preserve the existing fallback-to-patient behavior on save. Provenance
            // is tracked via resolveSourcedValue; explicit copy-from-patient handling
            // is owned by the transparency UI work.
            insureeNumber: insureeNumberField.value ?? "",
            insuranceStatus: insuranceStatusField.value ?? "",
            accountId:
              account[0].find((option: any) => option.name === formData.accountId)?.id ||
              formData.accountId,
            rxtype:
              rxType[0].find((option: any) => option.text === formData.rxtype)?.id ||
              formData.rxtype ||
              "Kasse",
            // An FK column: "" is not a missing value to Postgres, it is an id
            // that does not exist. Guarded like the fields above.
            diagnosegroup: emptyToNull(
              diagnoseGroups[0].find((option: any) => option.code === formData.diagnosegroup)
                ?.id || formData.diagnosegroup
            ),

            Receiptpayer:
              insurer[0].find((option: any) => option.id === formData.chipcard)?.id ||
              formData.Receiptpayer,
            isCopaymentExempted: true, //as per new requirement all Bundeswehr Rezepte should be copayment exempt
            // therapyRxs:
            //   formData.therapyRxs
            //     ?.filter((therapy: any) => therapy.therapy.id !== "") // Filter out entries without therapy.therapyId or therapy.id
            //     .map((therapy: any) => ({

            //       frequency: therapy.frequency || "",

            //     })) || [],

            therapyRxs: (formData.therapyRxs || []) // Ensure formData.therapyRxs is an array or provide an empty array
              // MD-232: a row is real when it NAMES A TERM. Gating on
              // `therapy.id` dropped every freshly entered row (see rowNamesTerm).
              .filter(rowNamesTerm)
              .map((therapy: any) => {
                if (
                  !(therapy.frequency && therapy.frequency.id) ||
                  !rowNamesTerm(therapy) ||
                  !therapy.amount
                ) {
                  throw new Error(
                    "Bitte fügen Sie die Behandlung hinzu, um das Rezept zu speichern/bearbeiten (Therapie, Menge, Häufigkeit sind Pflichtfelder) und deaktivieren Sie auch die Zelle nach der Bearbeitung!"
                  );
                }
                const validTherapy = validateTherapy(
                  rowTermText(therapy),
                  safeMasterTablesData,
                  termOptions
                );
                const validFrequency = validateFrequency(
                  therapy.frequency.id,
                  safeMasterTablesData
                );
                if (!validTherapy || !validFrequency) {
                  throw new Error("Bitte geben Sie eine gültige Therapie und Häufigkeit ein.");
                }
                const tarifTherapy = getTherapyId(
                  safeMasterTablesData,
                  formData.tarifGroupId,
                  therapy.therapy.abbreviation
                );

                return {
                  ...therapy,
                  therapy: {
                    id: tarifTherapy,
                    abbreviation: therapy.therapy.abbreviation,
                    ...therapy.therapy,
                  },
                };
              }),
          };
          if (currentDoctor) {
            updatedRxValues.doctorId = (currentDoctor as any).id || formData.doctorId;
            updatedRxValues.LANR = (currentDoctor as any).LANR || formData.doctorNumber || "";
          } else {
            updatedRxValues.doctor = null;
            updatedRxValues.doctorId = null;
            updatedRxValues.doctorNumber = "";
            updatedRxValues.LANR = "";
          }
          if (currentClinic) {
            updatedRxValues.clinicId = currentClinic.id || formData.clinicId;
            updatedRxValues.BSNR = (currentClinic as any).BSNR || formData.practiceNumber || "";
          } else {
            updatedRxValues.clinic = null;
            updatedRxValues.clinicId = null;
            updatedRxValues.practiceNumber = "";
            updatedRxValues.BSNR = "";
          }

          setUnsavedChanges(false);
          setFormData(updatedRxValues);
          if (entryType === EntryType.newRx && handleNewFormData) {
            handleNewFormData(updatedRxValues);
          } else {
            patientSaveRxs({ patientId: patientId!, rxs: [updatedRxValues] });
            onCloseRx()
          }
         
          // await searchPatient({ id: patientValues.id });
        setUnsavedChanges(false);
        } else {
          notificationStore.showMessage(
            "Bitte füllen Sie alle erforderlichen Felder aus",
            "warning"
          );
        }
      } catch (error: any) {
        console.error("Error saving Rx:", error);
        notificationStore.showMessage(
          error.message || "Fehler beim Speichern des Rezepts",
          "error",
          error
        );
      } finally {
        // Set loading back to false when the API call is complete
        setLoading(false);
        
      }
    };

    const [therapyRxs, setTherapyRxs] = useState(formData.therapyRxs); // State to manage therapyRxs array
    const componentRef = useRef(null);
    const handleDuplicateRow = (
      index: number,
      event: React.ChangeEvent<HTMLInputElement>,
      idValue?: string
    ) => {
      const { value } = event.target;
      // console.log("handleDuplicateRow called", { index, value }, event);
      setUnsavedChanges(true);

      const updatedTherapyRxs = formData.therapyRxs.map((therapy: any, index: number) => {
        // Check if the current therapy matches the ID we're updating
        if (therapy.id === idValue) {
          // No even-amount gate: nothing splits the amount in half any more
          // (that was the old shadow-line model). Odd totals with doubling are
          // legal — e.g. 7 units at 2/day = 3 double days + 1 single.
          const updatedTherapy = {
            ...therapy,
            isDoubled: value as any,
            unitsPerDay: value ? 2 : 1,
            amount: therapy.amount,
          };

          // Check for duplicate therapies
          const isDuplicate = formData.therapyRxs.some((othertherapy, otherIndex) => {
            if (otherIndex !== index) {
              // Compare relevant properties
              return updatedTherapy.therapy.abbreviation === othertherapy.therapy.abbreviation;
            }
            return false;
          });

          if (isDuplicate) {
            notificationStore.showMessage(
              "Die Behandlung ist bereits beendet, so dass kein Duplikat zulässig ist.",
              "warning"
            );
            // Return the therapy as is to avoid changes
            return therapy;
          }

          // Return the updated therapy if all conditions are met
          return updatedTherapy;
        }

        // Return the therapy as is if the ID doesn't match
        return therapy;
      });

      // Update the formData state with the updated therapyRxs
      setFormData((prevFormData) => ({
        ...prevFormData,
        therapyRxs: updatedTherapyRxs,
      }));

    };

    const [filteredDiagnoseGroups, setFilteredDiagnoseGroups] = useState([]);

    const filterDiagnoseGroups = (rxtype: any) => {
      const filtered = diagnoseGroups[0]?.filter(
        (option: any) =>
          option.RxType?.id === rxtype &&
          (!option.therapyType || option.therapyType === accountTherapyType)
      );
      setFilteredDiagnoseGroups(filtered);
    };

    useEffect(() => {
      filterDiagnoseGroups(formData.rxtype);
    }, [formData.rxtype, accountTherapyType]);

    // console.log("formData", formData, readOnlyView);

    const handlePracticeNumberInteraction = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      // For Bundeswehr Rxs: allow any non-empty value to trigger lookup (no 9-digit restriction)
      if ((e.type === "blur" || isTriggerKey) && value.length >= 0) {
        try {
          if (value.length > 0) {
            const clinicData = (await getClinicById(value)) as ClinicForModal;
            if (clinicData) {
              setDoesClinicExist(true);
              setCurrentClinic(clinicData);
              setFormData((prev) => ({ ...prev, clinicId: clinicData.id }));
              setShowClinicData(true);
            } else {
              // const inputValue = selectedBSNR || formData?.practiceNumber;
              setDoesClinicExist(false);
              setCurrentClinicId(value);
              setCurrentDoctorId(currentDoctor?.id || "");
              setShowClinicData(false);
              setCurrentClinic(undefined);
              setIsClinicModalOpen(true);
            }
          } else if (value.length === 0) {
            setCurrentClinic(undefined);
          }
        } catch (error) {}
      } else {
      }
    };

    const handleGetDoctorById = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      // For Bundeswehr Rxs: allow any non-empty value to trigger lookup (no 9-digit restriction)
      if ((e.type === "blur" || isTriggerKey) && value.length >= 0) {
        try {
          if (value.length > 0) {
            const doctorData: any = await getDoctorById(value);
            // console.log("doctor DATA -------> ", doctorData);
            if (doctorData) {
              setDoesDoctorExist(true);
              setCurrentDoctor(doctorData);
              setFormData((prev) => ({ ...prev, doctorId: doctorData.id }));
              // Only check association if currentClinic is set and valid
              if (currentClinic && currentClinic.id) {
                const isDoctorInClinic = doctorData.clinics?.some(
                  (clinic: any) => clinic.id === currentClinic.id
                );
                if (isDoctorInClinic) {
                  notificationStore.showMessage(
                    "This doctor exists and is already associated with this clinic",
                    "success"
                  );
                } else {
                  const confirmed = await confirmDoctorClinicJoin(doctorData, currentClinic);
                  if (!confirmed) {
                    // User cancelled — clear the doctor selection (treat as a mistake).
                    setCurrentDoctor(undefined);
                    setDoesDoctorExist(false);
                    setFormData((prev) => ({ ...prev, doctorId: "", doctorNumber: "" }));
                    return;
                  }
                  notificationStore.showMessage(
                    "This doctor exists already and will now get associated with this clinic",
                    "success"
                  );
                  handleAssociateDoctorToClinic(doctorData);
                }
              } else {
                // No clinic entered yet, just set doctor, do not associate
                notificationStore.showMessage(
                  "Bitte geben Sie zuerst eine gültige Betriebsstätten-Nr. (BSNR) ein.",
                  "warning"
                );
              }
            } else {
              setDoesDoctorExist(false);
              setIsClinicModalOpen(true);
              setCurrentDoctorId(value);
              setCurrentClinicId(currentClinic?.id || "");
            }
          } else if (value.length === 0) {
            setCurrentDoctor(undefined);
          }
        } catch (error) {}
      }
    };

    enum ReportMethod {
      Email = "Email",
      Fax = "Fax",
      Post = "Post",
    }

    const handleAssociateDoctorToClinic = async (doctorData: any) => {
      const createDoctorClinicDto = {
        id: doctorData?.id || "",
        contactInfo: {
          salutation: doctorData?.contactInfo?.salutation || "",
          firstNames: doctorData?.contactInfo?.firstNames || "",
          lastName: doctorData?.contactInfo?.lastName || "",
        },
        clinics: [
          {
            id: currentClinic?.id || "",
            contactInfo: {
              businessName: currentClinic?.contactInfo?.businessName || "",
              phone1: currentClinic?.contactInfo?.phone1 || "",
              fax: currentClinic?.contactInfo?.fax || "",
              addressLine1: currentClinic?.contactInfo?.addressLine1 || "",
              addressLine2: currentClinic?.contactInfo?.addressLine2 || "",
              city: currentClinic?.contactInfo?.city || "",
              zip: currentClinic?.contactInfo?.zip || "",
              email: currentClinic?.contactInfo?.email || "",
            },
            notes: currentClinic?.notes || "",
            methodForDrReport: (currentClinic?.methodForDrReport as ReportMethod) || "Email",
            methodForRxOrder: (currentClinic?.methodForRxOrder as ReportMethod) || "Email",
          },
        ],
      };

      // Call createDoctorWithClinic to save data
      // setLoading(true);
      try {
        const response = await createDoctorWithClinic(createDoctorClinicDto);
        return response;
      } catch (error) {
        console.error("Error saving doctor and clinic:", error);
      } finally {
        setLoading(false);
      }
    };

    // useEffect(() => {
    //   const inputValue = selectedBSNR || formData?.practiceNumber;
    //   const isEmpty = !inputValue || inputValue.trim() === "";

    //   if (isEmpty === false) {
    //     setIsDoctorNumberDisabled(false);
    //   }
    // }, [selectedBSNR, formData?.practiceNumber, currentClinic?.id]);

    const FormContent = (
      <Grid
        container
        direction={"row"}
        spacing={1}
        xs={12}
        sx={{
          paddingTop: "0px",
          paddingLeft: "2px",
          border: "0px dashed blue",
        }}
      >
        {!readOnlyView ? (
          <Grid item xs={12} md={3} sx={{ border: "0px dashed green" }}>
            <FlatCard title={`Rezept ${rxFormData?.rxNumber || ""}`}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Controls.Select
                    name="rxtype"
                    label="Rezept-typ"
                    value={formData?.rxtype}
                    onChange={handleInputChange}
                    options={rxType[0]?.map((option: any) => ({
                      label: option?.text.toString(),
                      value: option?.text.toString(),
                      id: option?.id.toString(),
                    }))}
                    disabled={readOnlyView}
                    style={{
                      width: "100%",
                      marginTop: "0px",
                      marginBottom: "0px",
                      fontSize: "10px",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Select
                    id={1}
                    name="accountId"
                    label="Mandant"
                    value={formData?.accountId}
                    onChange={handleInputChange}
                    options={accounts?.map((option: any) => ({
                      label: option?.name?.toString(),
                      value: option?.name?.toString(),
                      id: option?.id?.toString(),
                    }))}
                    disabled={readOnlyView}
                    style={{
                      width: "100%",
                      marginTop: "0px",
                      marginBottom: "0px",
                      fontSize: "10px",
                    }}
                    required
                    error={rxerrors.accountId}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Select
                    name="status"
                    label="Rezeptverbleib"
                    value={formData?.status}
                    onChange={handleInputChange}
                    options={[
                      {
                        label: "noch nicht erstellt",
                        value: "noch nicht erstellt",
                      },
                      { label: "beim Patient", value: "beim Patient" },
                      { label: "beim Therapeut", value: "beim Therapeut" },
                      { label: "vorhanden", value: "vorhanden" },
                    ]}
                    disabled={readOnlyView}
                    style={{
                      width: "100%",
                      marginTop: "0px",
                      marginBottom: "0px",
                      fontSize: "10px",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Select
                    name="tarifGroupId"
                    label="Tarif Group"
                    id={1}
                    value={formData?.tarifGroupId}
                    onChange={handleInputChange}
                    options={tarifGroupOptions.map((value: any) => ({
                      label: value.toString(),
                      value: value.toString(),
                    }))}
                    disabled={readOnlyView}
                    style={{
                      width: "100%",
                      marginTop: "0px",
                      marginBottom: "0px",
                      fontSize: "10px",
                    }}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Checkbox
                    name="isPerpetual"
                    label="Dauerrezept"
                    value={formData?.isPerpetual}
                    onChange={handleInputChange}
                    disabled={readOnlyView}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Select
                    disabled={readOnlyView}
                    name="Receiptpayer"
                    label="Kostenträger"
                    id={1}
                    value={selectedPayer || formData.Receiptpayer}
                    onChange={handleInputChange}
                    options={insurer[0]
                      ?.filter((item: any) => item.id === "Bundeswehr")
                      .map((option: any) => ({
                        label: option.ik.toString(),
                        value: option.name.toString(),
                        id: option.id.toString(),
                      }))}
                  />
                </Grid>
              </Grid>
            </FlatCard>

            <DoctorClinicAutocomplete
              onSelect={(doctor, clinic) => {
                setCurrentDoctor(doctor as any);
                setCurrentClinic(clinic as any);
                setFormData((prev) => ({
                  ...prev,
                  doctorId: doctor.id,
                  clinicId: clinic.id,
                  doctorNumber: doctor.LANR || "",
                  practiceNumber: clinic.BSNR || "",
                }));
                setDoesClinicExist(true);
                setDoesDoctorExist(true);
                setShowClinicData(true);
                setUnsavedChanges(true);
              }}
              onAddNew={(searchTerm) => {
                setAutocompleteSearchTerm(searchTerm);
                setCurrentClinicId("");
                setCurrentDoctorId("");
                setIsClinicModalOpen(true);
              }}
            />

            <DoctorCard
              doctor={currentDoctor}
              clinic={currentClinic}
              formData={{
                doctorNumber: formData.doctorNumber,
                signatureStatus: formData.signatureStatus,
                clinic: currentClinic,
              }}
              showSignatureCheck={!readOnlyView}
              readOnlyView={readOnlyView}
              onInputChange={handleInputChange}
              onEdit={() => {
                setCurrentClinicId(currentClinic?.id || "");
                setCurrentDoctorId(currentDoctor?.id || "");
                setIsClinicModalEditMode(true);
                setIsClinicModalOpen(true);
              }}
              onRemoveDoctor={() => {
                setCurrentDoctor(undefined as any);
                setFormData((prev: any) => ({
                  ...prev,
                  doctor: undefined,
                  doctorId: "",
                  doctorNumber: "",
                  LANR: "",
                }));
                setUnsavedChanges(true);
              }}
              onRemoveClinic={() => {
                setCurrentClinic(undefined as any);
                setFormData((prev: any) => ({
                  ...prev,
                  clinic: undefined,
                  clinicId: "",
                  practiceNumber: "",
                  BSNR: "",
                }));
                setUnsavedChanges(true);
              }}
              onMigrationComplete={(type, newValue) => {
                if (type === "doctor") {
                  setFormData((prev: any) => ({ ...prev, doctorNumber: newValue }));
                  const doctorPK = currentDoctor?.id || (currentDoctor as any)?.id;
                  if (doctorPK) getDoctorById(doctorPK).then((doc) => { if (doc) setCurrentDoctor(doc as any); });
                } else {
                  setFormData((prev: any) => ({ ...prev, practiceNumber: newValue }));
                  const clinicPK = currentClinic?.id;
                  if (clinicPK) getClinicById(clinicPK).then((cli) => { if (cli) setCurrentClinic(cli as any); });
                }
              }}
            />

            <FlatCard title=" Heilmittel nach Maßgabe des Kataloges" sx={{ width: "400px" }}>
              <Table
                sx={{
                  borderCollapse: "collapse",
                  width: "100%",
                  border: "1px solid #ccc",
                  background: "white",
                }}
              >
                <TableBody sx={{ maxHeight: "50px", overflowY: "scroll" }}>
                  <TableCell>Aktionen</TableCell>
                  <TableCell>Heilmittel</TableCell>
                  <TableCell>Menge</TableCell>
                  <TableCell>Series</TableCell>
                  {formData?.therapyRxs.map((therapy, rowIndex) => (
                    <TableRow
                      key={rowIndex}
                      // style={{ border: "1px solid red", height: "1px" }}
                    >
                      <TableCell sx={{ padding: "0px", width: "50px", height: "1px" }}>
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteTherapy(therapy.id)}
                          disabled={readOnlyView} // Prevent deletion in read-only mode
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "0px",
                          width: "30px",
                          height: "1px",
                        }}
                      >
                        <TherapyTermField
                            therapyType={accountTherapyType}
                          disabled={readOnlyView}
                          name="therapy"
                          label=""
                          value={therapy.therapy.abbreviation}
                          onChange={(event: any) => handleInputChange(event, rowIndex)}
                          // options={therapyOptions[0]
                          //   ?.filter((therapyObj: any) => therapyObj.duration)
                          //   ?.map((therapy: any) => ({
                          //     label: therapy?.abbreviation?.toString(),
                          //     value: therapy?.abbreviation?.toString(),
                          //   }))}
                          style={{
                            width: "100px",
                            marginTop: "0px",
                            marginBottom: "0px",
                            fontSize: "10px",
                          }}
                        />
                      </TableCell>
                      {/* <TableCell
                            sx={{
                              padding: "0px",
                              direction: "column",
                              height: "1px",
                            }}
                          >
                            <Typography sx={{ fontSize: "10px" }}>
                              {therapy.therapy.description}
                            </Typography>
                          </TableCell> */}
                      <TableCell
                        sx={{
                          padding: "0px",
                          width: "10px",
                          height: "1px",
                        }}
                      >
                        <Controls.Checkbox
                          name="doubled"
                          value={therapy.isDoubled}
                          label={
                            <Typography sx={{ fontSize: "10px" }}>Doppelbehandlung</Typography>
                          }
                          disabled={!therapy.therapy.abbreviation || readOnlyView}
                          onChange={(event: any) => {
                            handleDuplicateRow(rowIndex, event, therapy.id);
                          }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "0px",
                          width: "50px",
                          height: "1px",
                          borderLeft: "1px solid #ccc",
                        }}
                      >
                        <Controls.Input
                          name="amount"
                          disabled={readOnlyView}
                          label=""
                          value={therapy.amount}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            handleInputChange(event, rowIndex, therapy.id);
                          }} // Pass rowIndex to handleInputChange
                          style={{ width: "100%", margin: "0px" }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          padding: "0px",
                          width: "80px",
                          height: "1px",
                          borderLeft: "1px solid #ccc",
                        }}
                      >
                        <Controls.Select
                          name="rxSeries"
                          // label="Rezeptverbleib"
                          id={1}
                          style={{ width: "100%", margin: "0px" }}
                          value={therapy.rxSeries?.label}
                          onChange={(event: any) => handleInputChange(event, rowIndex, therapy.id)}
                          options={savedSeriesForPatient.map((option: any) => ({
                            label: option.label,
                            value: option.label,
                            id: option.id,
                          }))}
                          onBlur={true}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </FlatCard>

            {/* <Controls.Input
              name="practiceNumber"
              label="BSNR"
              value={selectedBSNR || formData?.practiceNumber}
              onChange={handleInputChange}
            /> */}
          </Grid>
        ) : (
          <Grid item xs={12} md={3} sx={{ border: "0px dashed green" }}>
            <FlatCard title="Allgemein" sx={{ marginBottom: "2px" }}>
              <Grid container spacing={0} justifyContent="space-between">
                {/* First Row */}
                <Grid item xs={5}>
                  <Typography textAlign="left" sx={{ fontSize: "0.8em" }}>
                    Rezept-Typ:
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Controls.Chip
                    label={formData.rxtype || "-"}
                    sx={{ width: "100%", fontSize: "0.7rem" }}
                  />
                </Grid>

                {/* Second Row */}
                <Grid item xs={5}>
                  <Typography textAlign="left" style={{ fontSize: "0.8rem" }}>
                    Mandant:
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Controls.Chip
                    label={formData.accountId || "-"}
                    sx={{ width: "100%", fontSize: "0.7rem", padding: "0px" }}
                  />
                </Grid>

                {/* Third Row */}
                <Grid item xs={5}>
                  <Typography textAlign="left" style={{ fontSize: "0.8rem" }}>
                    Rx Location:
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Controls.Chip
                    label={
                      formData.isHomeVisit === true
                        ? "Haus/Heim"
                        : formData.isHomeVisit === false
                        ? "Praxis"
                        : "-"
                    }
                    sx={{ width: "100%", fontSize: "0.7rem" }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controls.Select
                    name="processingStatus"
                    label="Status"
                    onChange={updateRxProcessingStatus}
                    value={formData?.processingStatus || RxDtoProcessingStatusEnum.InBehandlung}
                    options={Object.values(RxDtoProcessingStatusEnum).map((value) => ({
                      value: value,
                      label: value,
                    }))}
                    noTriggerChange={true}
                    // style={{
                    //   width: "100%",
                    //   marginTop: "0px",
                    //   marginBottom: "0px",
                    //   fontSize: "10px",
                    // }}
                  />
                </Grid>
              </Grid>
            </FlatCard>
            {rxFormData && (
              <FlatCard 
                title="Validierung" 
                sxContent={{ 
                  p: 0, 
                  overflow: "hidden",
                  "&:last-child": { 
                    paddingBottom: 1 
                  }
                }}
              >
                <Box 
                  sx={{ 
                    maxHeight: "400px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: 0,
                    "&::-webkit-scrollbar": {
                      width: "4px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "transparent",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "2px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#555",
                    },
                  }}
                >
                  <ValidationCard
                    patientData={patientValues}
                    selectedRx={formData}
                    form={formType.SHORT}
                  />
                </Box>
              </FlatCard>
            )}
            <FlatCard
              title="Rezepthinweise"
              sxContent={{ p: 0.75 }}
              sx={{
                paddingTop: "5px",
                marginBottom: "8px",
                textAlign: "left",
              }}
            >
              <Notes notes={rxNotes} setNotes={updateNote} maxVisibleNotes={3} noteKind="Rezepthinweis" />
            </FlatCard>

            <DoctorCard
              doctor={currentDoctor}
              clinic={currentClinic}
              formData={{
                doctorNumber: formData?.doctorNumber,
                clinic: formData?.clinic,
              }}
              showSignatureCheck={false}
              readOnlyView={true}
              sx={{ paddingTop: "5px", marginBottom: "8px", textAlign: "left" }}
            />
            
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            paddingLeft: !readOnlyView ? "40px !important" : "0px",
          }}
        >
          {" "}
          {/* transparent border color is a hack because i couldnt figure out any way to add top padding*/}
          <ScalableComponentSimple occupiedHeight={readOnlyView ? 0.8 : 1.2}>
            <Container
              sx={{ border: "0px solid yellow" }}
              className={classes.container}
              ref={componentRef}
            >
              {/* Small box */}
              <form onSubmit={handleGenericSubmit} className={classes.form}>
                <Grid container spacing={1}>
                  <Grid item sx={{ border: "0px solid green" }}>
                    <Typography
                      sx={{
                        fontSize: "25px",
                        fontWeight: "bold",
                        fontFamily: "initial",
                        color: "#0ddcdc",
                      }}
                    >
                      Bundeswehr Heilmittelverordnung
                    </Typography>
                    <Typography sx={{ fontSize: "20px", color: "#0ddcdc" }}>
                      - Zuzahlungsfrei-
                    </Typography>
                    <div className={classes.box}>
                      <Grid container spacing={1} sx={{ flexGrow: 1 }}>
                        {/* First Column: Checkboxes */}
                        <Grid item xs={7}>
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <Controls.Checkbox
                                disabled
                                name=""
                                label={
                                  <Typography className={classes.typography}>
                                    Physiotherapie
                                  </Typography>
                                }
                                value={accountTherapyType === "Physiotherapie"}
                                onChange={handleInputChange}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Controls.Checkbox
                                disabled={readOnlyView}
                                name=""
                                label={
                                  <Typography className={classes.typography}>
                                    Erweiterte ambulante(EAP)
                                  </Typography>
                                }
                                value={false}
                                onChange={handleInputChange}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Controls.Checkbox
                                disabled={readOnlyView}
                                name=""
                                label={
                                  <Typography className={classes.typography}>
                                    Podologische
                                  </Typography>
                                }
                                value={false}
                                onChange={handleInputChange}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Controls.Checkbox
                                disabled={readOnlyView}
                                name=""
                                label={
                                  <Typography className={classes.typography}>
                                    Stim-/Sprech-/Sprach
                                  </Typography>
                                }
                                value={false}
                                onChange={handleInputChange}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Controls.Checkbox
                                disabled={readOnlyView}
                                name=""
                                label={
                                  <Typography className={classes.typography}>
                                    Ernährungstherapie
                                  </Typography>
                                }
                                value={false}
                                onChange={handleInputChange}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Controls.Checkbox
                                disabled
                                name=""
                                label={
                                  <Typography className={classes.typography}>
                                    Ergotherapie
                                  </Typography>
                                }
                                value={accountTherapyType === "Ergotherapie"}
                                onChange={handleInputChange}
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={5} alignItems="center">
                          <div className={classes.box}>
                            <Grid item xs={12}>
                              <Typography className={classes.typography}>
                                Nur gültig bei Behandlungsbeginn innerhalb von{" "}
                                <Controls.Select
                                  name="validStartWindow"
                                  label=""
                                  value={formData?.validStartWindow}
                                  onChange={handleInputChange}
                                  options={[
                                    { label: "4", value: "4" },
                                    { label: "3", value: "3" },
                                  ]}
                                  disabled={readOnlyView}
                                  style={{
                                    width: "50px", // Adjust this width according to your needs
                                    marginTop: "0px",
                                    marginBottom: "0px",
                                    fontSize: "10px",
                                    display: "inline-block", // Ensures it stays on the same line
                                    verticalAlign: "middle", // Aligns it with the text
                                  }}
                                />{" "}
                                Wochen ab Verordnungsdatum.
                              </Typography>
                              <Typography className={classes.typography}>
                                Verordnung gültig bis Ende (Monat/Jahr)
                              </Typography>{" "}
                              <Controls.DatePicker
                                disabled={readOnlyView}
                                name="rxExpireDate"
                                label=""
                                value={formData?.rxExpireDate}
                                onChange={handleInputChange}
                                variant="standard"
                                style={{
                                  width: "60%",
                                  padding: "0px",
                                  margin: "0px",
                                  fontSize: "10px",
                                  "& .MuiInputBase-input": {
                                    padding: 0,
                                    margin: 0,
                                    paddingRight: "0px",
                                  },
                                }}
                                formatDate="MM.yyyy"
                                disabledFormat="MM.yyyy"
                              />
                            </Grid>
                          </div>
                          <div className={classes.box}>
                            <Grid>
                              <Grid item xs={12}>
                                <Controls.Checkbox
                                  disabled={readOnlyView}
                                  name="urgent"
                                  label={
                                    <Typography className={classes.typography}>
                                      Dringlicher Behandlungsbedarf innerhalb von 14 Tagen
                                    </Typography>
                                  }
                                  value={formData?.urgent}
                                  onChange={handleInputChange}
                                />
                              </Grid>
                            </Grid>
                            <Grid container alignItems="center">
                              <Grid item xs={12}>
                                <Typography className={classes.typography}>
                                  Verletzung/Schaden möglicherweise durch Bw-Anghörige(n) oder
                                  Dritte(n) verursacht
                                </Typography>
                              </Grid>
                              <Grid item xs={4}>
                                <Controls.Checkbox
                                  disabled={readOnlyView}
                                  name=""
                                  label={
                                    <Typography className={classes.typography}>Nein</Typography>
                                  }
                                  value={true}
                                  onChange={handleInputChange}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <Controls.Checkbox
                                  disabled={readOnlyView}
                                  name=""
                                  label={<Typography className={classes.typography}>Ja</Typography>}
                                  value={false}
                                  onChange={handleInputChange}
                                />
                              </Grid>
                            </Grid>
                          </div>
                        </Grid>
                      </Grid>
                    </div>

                    {/* </Grid> */}
                    {/* Form content */}

                    {/* <Grid container spacing={2}> */}
                    <div className={classes.box}>
                      <Grid container spacing={2}>
                        {/* First Field: Krankenkasse bzw. Kostenträger */}
                        <Grid item xs={6}>
                          <Grid container alignItems="center">
                            <Grid item xs={8}>
                              <Typography className={classes.typography}>
                                Personenkennziffer
                              </Typography>
                            </Grid>
                          </Grid>
                          <div
                            style={{
                              height: "30px",
                              borderRight: "1px solid #069191",
                            }}
                          >
                            <Controls.Input
                              disabled={readOnlyView}
                              name="insureeNumber"
                              label=""
                              value={insureeNumberField.value || ""}
                              onChange={handleInputChange}
                              style={{ width: "100%", margin: "0px" }}
                            />
                            {/* <Controls.Select
                              disabled={readOnlyView}
                              name="Receiptpayer"
                              label=""
                              id={1}
                              value={selectedPayer || formData.Receiptpayer}
                              onChange={handleInputChange}
                              options={insurer[0]?.map((option: any) => ({
                                label: option.ik.toString(),
                                value: option.name.toString(),
                                id: option.id.toString(),
                              }))}
                              style={{
                                width: "100%",
                                marginTop: "0px",
                                marginBottom: "0px",
                                fontSize: "10px",
                              }}
                            /> */}
                          </div>
                        </Grid>

                        {/* Second Field: Name, Vorname des Versicherten */}
                        <Grid item xs={6}>
                          <Grid container alignItems="center">
                            <Grid item xs={8}>
                              <Typography className={classes.typography}>Name, Vorname</Typography>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            spacing={2}
                            alignItems="center"
                            sx={{ borderRight: "1px solid #069191" }}
                          >
                            <Grid item xs={12}>
                              <Controls.Input
                                disabled
                                name=""
                                label=""
                                value={`${patientLastName} ${patientFirstName}`.trim()}
                                onChange={handleInputChange}
                                style={{ width: "100%", margin: "0px" }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                    <div className={classes.box}>
                      <Grid container spacing={1}>
                        <Grid item xs={2}>
                          <Grid container alignItems="center" spacing={1}>
                            {/* Erstverordnung with Checkbox */}
                            <Grid item xs={6}>
                              <Grid container alignItems="center">
                                <Typography className={classes.typography}>Erstveror</Typography>
                                <Controls.Checkbox
                                  disabled
                                  name=""
                                  value={false}
                                  onChange={handleInputChange}
                                />
                              </Grid>
                            </Grid>

                            {/* Folgeverordnung with Checkbox */}
                            <Grid item xs={6}>
                              <Grid container alignItems="center">
                                <Typography className={classes.typography}>Folgeveror</Typography>
                                <Controls.Checkbox
                                  disabled
                                  name=""
                                  value={false}
                                  onChange={handleInputChange}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={2}>
                          <Grid container alignItems="center" spacing={1}>
                            {/* Erstverordnung with Checkbox */}
                            <Grid item xs={12}>
                              <Grid
                                container
                                alignItems="center"
                                sx={{ borderLeft: "1px solid #069191" }}
                              >
                                <Typography className={classes.typography}>Verordnung</Typography>
                                <Controls.Checkbox
                                  disabled
                                  label={
                                    <Typography className={classes.typography}>
                                      vom Regelfall utV
                                    </Typography>
                                  }
                                  name=""
                                  value={false}
                                  onChange={handleInputChange}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={2}>
                          <Grid container alignItems="center" spacing={1}>
                            {/* Erstverordnung with Checkbox */}
                            <Grid item xs={12}>
                              <Grid
                                container
                                alignItems="center"
                                sx={{ borderLeft: "1px solid #069191" }}
                              >
                                <Typography className={classes.typography}>
                                  Gruppentherapie
                                </Typography>
                                <Controls.Checkbox
                                  disabled
                                  name=""
                                  value={false}
                                  onChange={handleInputChange}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={3} sx={{ borderLeft: "1px solid #069191" }}>
                          <Typography
                            variant="body1"
                            className={classes.typography}
                            sx={{ marginRight: "8px" }}
                          >
                            Hausbesuch
                          </Typography>
                          <FormControlLabel
                            label=""
                            control={
                              <>
                                <Checkbox
                                  checked={formData.isHomeVisit === true}
                                  onChange={handleCheckboxChange}
                                  disabled={readOnlyView}
                                  name="visitTypeCheckboxJa"
                                  value="yes"
                                />
                                <Typography variant="body1">ja</Typography>
                                <Checkbox
                                  checked={formData.isHomeVisit === false}
                                  onChange={handleCheckboxChange}
                                  disabled={readOnlyView}
                                  name="visitTypeCheckboxNein"
                                  value="no"
                                />
                                <Typography variant="body1">nein</Typography>
                              </>
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sx={{ borderLeft: "1px solid #069191" }}>
                          <Typography className={classes.typography}>Therapiebericht</Typography>
                          <FormControlLabel
                            label=""
                            control={
                              <>
                                <Checkbox
                                  checked={formData.therapyReport === true}
                                  onChange={handleInputChange}
                                  disabled={readOnlyView}
                                  name="therapyReport"
                                  value="yes"
                                />
                                <Typography className={classes.typography}>Ja</Typography>
                                <Checkbox
                                  checked={formData.therapyReport === false}
                                  onChange={handleInputChange}
                                  disabled={readOnlyView}
                                  name="therapyReport"
                                  value="no"
                                />
                                <Typography className={classes.typography}>Nein</Typography>
                              </>
                            }
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div className={classes.box}>
                      <Grid
                        container
                        spacing={1}
                        sx={{
                          paddingTop: "2px",
                          // borderBottom: "1px solid black",
                        }}
                      >
                        <Grid item xs={12}>
                          <Table
                            sx={{
                              borderCollapse: "collapse",
                              width: "100%",
                              border: "1px solid #069191",
                              background: "white",
                              fontSize: "10px", // Adjust font size for compactness
                              tableLayout: "auto", // Allows table and cells to adjust width based on content
                            }}
                          >
                            <TableBody>
                              <TableRow>
                                <TableCell
                                  sx={{
                                    borderLeft: "1px solid #069191",
                                    padding: "2px",
                                    fontSize: "10px",
                                    whiteSpace: "nowrap",
                                  }}
                                  className={classes.typography}
                                >
                                  Verordnungs-menge
                                </TableCell>
                                <TableCell
                                  sx={{
                                    borderLeft: "1px solid #069191",
                                    padding: "2px",
                                    fontSize: "10px",
                                    whiteSpace: "normal", // Allow wrapping
                                    wordBreak: "break-word", // Break long words to wrap text
                                  }}
                                  className={classes.typography}
                                >
                                  Heilmittel nach Maßgabe Verordnungshilfe Physiotherapie
                                  Bundeswehr/ Heilmittelkatalog G-BA (ggf. gebräuchliche Abkürzungen
                                  des Heilmittelkataloges)
                                </TableCell>

                                <TableCell
                                  sx={{
                                    borderLeft: "1px solid #069191",
                                    padding: "2px",
                                    fontSize: "10px",
                                    whiteSpace: "nowrap",
                                  }}
                                  className={classes.typography}
                                >
                                  Anzahl pro Woche
                                </TableCell>
                              </TableRow>
                              {formData?.therapyRxs.map((therapy: any, rowIndex: any) => (
                                <TableRow key={rowIndex}>
                                  <TableCell
                                    sx={{
                                      borderLeft: "1px solid #069191",
                                      padding: "2px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <Controls.Input
                                      name="amount"
                                      label=""
                                      value={therapy.amount}
                                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                        handleInputChange(event, rowIndex, therapy.id)
                                      }
                                      disabled={readOnlyView}
                                      sx={{
                                        fontSize: "10px",
                                        minWidth: "60px",
                                        padding: "0px !important",
                                      }} // Minimum width to ensure usability
                                    />
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      borderLeft: "1px solid #069191",
                                      padding: "2px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <TherapyTermField
                            therapyType={accountTherapyType}
                                      name="therapy"
                                      id={1}
                                      label=""
                                      value={therapy.therapy.abbreviation}
                                      onChange={(event: any) => handleInputChange(event, rowIndex)}
                                      sx={{
                                        fontSize: "10px",
                                        minWidth: "100px", // Minimum width to ensure usability
                                        padding: "0px !important",
                                      }}
                                      disabled={readOnlyView}
                                    />
                                  </TableCell>

                                  <TableCell
                                    sx={{
                                      borderLeft: "1px solid #069191",
                                      padding: "2px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <Controls.Input
                                      name="frequency"
                                      label=""
                                      value={therapy.frequency?.id}
                                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                        handleInputChange(event, rowIndex, therapy.id)
                                      }
                                      disabled={readOnlyView}
                                      sx={{
                                        fontSize: "10px",
                                        minWidth: "60px",
                                      }} // Minimum width to ensure usability
                                    />
                                  </TableCell>
                                  {/* <TableCell sx={{ padding: "2px", whiteSpace: "nowrap" }}>
              <Controls.Checkbox
                name="doubled"
                value={therapy.isDoubled}
                label={<Typography  sx={{fontSize:"10px"}}>Doppelbehandlung</Typography>}
                disabled={!therapy.therapy.abbreviation || readOnlyView}
                onChange={(event: any) => handleDuplicateRow(rowIndex, event)}
              />
            </TableCell> */}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </Grid>
                      </Grid>
                    </div>
                    <div className={classes.box}>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Typography className={classes.typography}>
                            Diagnose mit Leitsymptomatik, ggf. wesentliche Befunde (Bei
                            Stimm-/Sprech-/Sprachtherapie Zusatzbefunde, Tonaudiometrie,
                            Laryngologischen Befund beifügen)
                          </Typography>
                          <Controls.TextArea
                            name="diagnosisText"
                            rows={4}
                            placeholder="Textdiagnose"
                            value={formData?.diagnosisText}
                            onChange={handleInputChange}
                            disabled={readOnlyView}
                            style={{ background: "white", width: "100%" }}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <div className={classes.box}>
                      {/* <Grid item xs={12}> */}
                      <Grid container spacing={1}>
                        <Grid
                          item
                          xs={12}
                          //   sx={{
                          //     display: "flex",
                          //     flexDirection: "column",
                          //     width: "100%",
                          //   }}
                        >
                          <Controls.TextArea
                            label={
                              <Typography className={classes.typography}>
                                Spezifizierung der Therapieziele
                              </Typography>
                            }
                            disabled={readOnlyView}
                            name="additionalNotes"
                            rows={4}
                            placeholder=""
                            value={formData?.additionalNotes}
                            onChange={handleInputChange}
                            style={{ background: "white", width: "100%" }}
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div className={classes.box}>
                      {/* <Grid item xs={12}> */}
                      <Grid container spacing={1}>
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <Controls.TextArea
                            label={
                              <Typography className={classes.typography}>
                                Empfehlung für die Verordnung außerhalb vorn Regelfall utV sowie EAP
                                durch Facharzt (ggf. Beiblatt) Fachrichtung, Datum Arztbericht:
                              </Typography>
                            }
                            disabled={readOnlyView}
                            name="additionalNotes2"
                            rows={4}
                            placeholder=""
                            value={formData?.additionalNotes2}
                            onChange={handleInputChange}
                            style={{ flex: 1, height: "100px " }}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    <div className={classes.box}>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Controls.TextArea
                            label={
                              <Typography className={classes.typography}>
                                Verordnende Ärztin/Verordnender Arzt
                              </Typography>
                            }
                            disabled
                            name="doctorData"
                            rows={5}
                            placeholder=""
                            value={
                              `${currentDoctor?.contactInfo?.salutation || ""} ${
                                currentDoctor?.contactInfo?.firstNames || ""
                              } ${currentDoctor?.contactInfo?.lastName || ""}\n` +
                              `${currentClinic?.contactInfo?.addressLine1 || ""}\n` +
                              `${currentClinic?.contactInfo?.addressLine2 || ""}\n` +
                              `${currentClinic?.contactInfo?.zip || ""}\n` +
                              `Tel: ${currentClinic?.contactInfo?.phone1 || ""}\n` + // Added "Tel:" label
                              `BSNR: ${currentClinic?.BSNR || ""}`
                            }
                            onChange={handleInputChange}
                            style={{ flex: 1 }}
                          />
                        </Grid>

                        <Grid
                          item
                          xs={6}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                          }}
                        >
                          <Controls.Input
                            label={<Typography className={classes.typography}>PLZ, Ort</Typography>}
                            disabled
                            name=""
                            rows={6}
                            placeholder=""
                            value={
                              `${currentClinic?.contactInfo?.zip || ""}` +
                              `${
                                currentClinic?.contactInfo?.addressLine1
                                  ? `, ${currentClinic.contactInfo.addressLine1}`
                                  : ""
                              }\n`
                            }
                            onChange={handleInputChange}
                            style={{ flex: 1 }}
                          />
                          <Typography className={classes.typography}>Datum</Typography>
                          <Controls.DatePicker
                            disabled={readOnlyView}
                            name="date"
                            label=""
                            value={formData?.date}
                            onChange={handleInputChange}
                            variant="standard"
                            style={{
                              width: "100%",
                              padding: "0px",
                              margin: "0px",
                              fontSize: "10px",
                              "& .MuiInputBase-input": {
                                padding: 0,
                                margin: 0,
                                paddingRight: "0px",
                              },
                            }}
                            formatDate="dd.MM.yy"
                          />
                          <Controls.Input
                            label={
                              <Typography className={classes.typography}>
                                Unterschrift, Namensstempel
                              </Typography>
                            }
                            disabled
                            name=""
                            rows={4}
                            placeholder=""
                            value={`${currentDoctor?.contactInfo?.salutation || "Dr."} ${
                              currentDoctor?.contactInfo?.firstNames || ""
                            } ${currentDoctor?.contactInfo?.lastName || ""}`}
                            onChange={handleInputChange}
                            style={{ flex: 1 }}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </form>
              <Modal
                open={loading}
                aria-labelledby="loading-modal-title"
                aria-describedby="loading-modal-description"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div>
                  <CircularProgress size={60} />
                </div>
              </Modal>
            </Container>
          </ScalableComponentSimple>
        </Grid>
        {!readOnlyView && (
          <Grid item xs={12} md={3} sx={{ border: "0px dotted black" }}>
            <FlatCard title="Validierung">
              <ValidationCard
                patientData={patientValues}
                selectedRx={
                  // patientValues?.rxs?.filter((rx: any) => rx.rxNumber === rxFormData?.rxNumber)[0]
                  formData
                }
                form={formType.LONG}
              />
            </FlatCard>
          </Grid>
        )}
        {unsavedChangesWarning && (
          <WarningDialog
            open={true} // Ensure the warning dialog is open
            onClose={handleCloseUnsavedChangesWarning} // Function to close the dialog
            onContinue={handleUnsavedChangesWarning} // Function to continue despite unsaved changes
            title="Änderungen speichern?"
            content="Du hast einige Änderungen gemacht. Möchtest du diese speichern, bevor du schließt?"
            isConfirmSave
          />
        )}
      </Grid>
    );

    // if (!selectedRxId || !entryType) {
    //   return (
    //     <Box p={2}>
    //       <span>Kein Rezept ausgewählt</span>
    //     </Box>
    //   );
    // }

    if (isRxLoading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" p={3}>
          <CircularProgress />
        </Box>
      );
    }

    if (rxError) {
      return (
        <Box p={2}>
          <span>Fehler beim Laden des Rezepts für {selectedRxId}</span>
        </Box>
      );
    }
    return !readOnlyView ? (
      <Dialog
        open={openRx as boolean}
        onClose={handleCloseRxDialog}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            position: "fixed",
            left: position === "right-third" ? `${window.innerWidth * 0.33}px` : "auto",
            top: position === "right-third" ? "50%" : "auto",
            transform: position === "right-third" ? "translateY(-50%)" : "none",
            width: position === "right-third" ? `${window.innerWidth * 0.67}px` : "auto",
            height: position === "right-third" ? "90vh" : "auto",
            maxWidth: position === "right-third" ? "none" : "1200px",
            margin: position === "right-third" ? "0" : "auto",
          },
        }}
      >
        <DialogTitle
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <span>Bundeswehr Dialog</span>
          <Button
            variant="outlined"
            size="small"
            onClick={() => setPosition(position === "default" ? "right-third" : "default")}
            sx={{ minWidth: "40px", padding: "4px 8px" }}
          >
            1
          </Button>
        </DialogTitle>
        <DialogContent>{FormContent}</DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleCloseRxDialog}>
            Abbrechen
          </Button>
          <Button variant="text" onClick={() => setDocumentViewerOpen(!documentViewerOpen)}>
            Dokumentviewer
          </Button>
          <Button onClick={handleGenericSubmit} variant="contained">
            Speichern
          </Button>
        </DialogActions>
        <VerordnungDialog
          openAddEditDialog={isClinicModalOpen}
          handleCloseAddEditDialog={() => { setIsClinicModalOpen(false); setIsClinicModalEditMode(false); }}
          clinicId={currentClinicId}
          setCreationResponse={setCreationResponse}
          doctorId={currentDoctorId}
          currentClinic={currentClinic}
          currentDoctor={currentDoctor}
          rxType="Bundeswehr"
          initialDoctorName={autocompleteSearchTerm}
          isEditMode={isClinicModalEditMode}
          // isDoctorNumberDisabled={isDoctorNumberDisabled}
        />

        {/* SimpleDocumentViewer Komponente */}
        <SimpleDocumentViewer
          open={documentViewerOpen}
          onClose={() => setDocumentViewerOpen(false)}
          position={position}
          patientId={patientValues?.id}
        />
      </Dialog>
    ) : (
      FormContent
    );
  }
);

export default Bundeswehr;
